import * as React from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import ConsultationList from './ConsultationList';
import ConsultationForm from './ConsultationForm';
import Button from '@mui/joy/Button';
import SnackbarComponent from '../../ui/SnackBarComponent';

const Consultation: React.FC = () => {
  const navigate = useNavigate();
  const [snackbarMessage, setSnackbarMessage] = React.useState<string>('');
  const [snackbarOpen, setSnackbarOpen] = React.useState<boolean>(false);
  const [snackbarColor, setSnackbarColor] = React.useState<'success' | 'error'>('success');

  const handleCreateConsultation = () => {
    navigate('/consultations/new');
  };

  const handleEditConsultation = (consultationId: number) => {
    navigate(`/consultations/edit/${consultationId}`);
  };

  const showSnackBar = (message: string, color: 'success' | 'error' = 'success') => {
    setSnackbarMessage(message);
    setSnackbarColor(color);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <React.Fragment>
      <Box>
        <Routes>
          <Route
            path="/"
            element={
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography level="h1">Consultations</Typography>                  
                </Box>
                <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 'sm', p: 2 }}>
                  <ConsultationList onEdit={handleEditConsultation} showSnackBar={showSnackBar} />
                </Box>  
              </Box>
            }
          />
          <Route
            path="new"
            element={<ConsultationForm onClose={() => navigate('/consultations')} consultationId={null} showSnackBar={showSnackBar} />}
          />
          <Route
            path="edit/:consultationId"
            element={<ConsultationFormWrapper onClose={() => navigate('/consultations')} showSnackBar={showSnackBar} />}
          />
        </Routes>
      </Box>
      <SnackbarComponent
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        color={snackbarColor}
      />
    </React.Fragment>
  );
};

const ConsultationFormWrapper: React.FC<{ onClose: () => void; showSnackBar: (message: string, color?: 'success' | 'error') => void }> = ({ onClose, showSnackBar }) => {
  const { consultationId } = useParams<{ consultationId: string }>();
  return <ConsultationForm onClose={onClose} consultationId={consultationId ? parseInt(consultationId) : null} showSnackBar={showSnackBar} />;
};

export default Consultation;
